<template>
  <b-modal size="md" v-model="show" centered title="Leistungsart wählen"
  >
    <b-row>
      <b-col style="height: 55vh; overflow: auto">
        <b-table thead-class="display_none" striped hover selectable :items="lears" :fields="lear_fields"
                 select-mode="single"
                 selectedVariant="primary"
                 @row-selected="rowSelectedGroup"
                 ref="group_table"
        >

        </b-table>
      </b-col>
    </b-row>
    <template #modal-footer="{ok, cancel}">
      <!-- Emulate built in modal footer ok and cancel button actions -->
      <b-button size="md" variant="primary" @click="onCancel">
        Abbrechen
      </b-button>
      <b-button size="md" :disabled="!canContinue" variant="success" @click="onSelected">
        Speichern
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import {Redirect_500, Redirect_Login, Server_URL} from "../../shared/utils";

export default {
  name: "SelectLegrDialog",
  data() {
    return {
      show: false,
      loader: undefined,
      lears: [],
      lear_fields: [{key: "name", label: 'Leistungsart wählen'}],
      selected: [],
      allowEmpty: false,
    }
  },
  computed: {
    canContinue() {
      return this.selected.length > 0 || this.allowEmpty;
    }
  },
  methods: {
    onSelected() {
      this.show = false;
      this.$emit("lear-selected", this.getReturnData());
    },
    onCancel() {
      this.show = false;
    },
    showDialog(lears, allowEmpty = false) {
      this.allowEmpty = allowEmpty;
      if (lears && lears.length) {
        lears.sort((a,b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0))
        this.lears = lears;
      }
      this.selected = [];
      this.show = true;
    },
    rowSelectedGroup(items) {
      if (items.length === 0) {
        this.selected = [];
      } else {
        this.selected = items;
      }
    },

    getReturnData: function () {
      return {
        selected_lear: this.selected.length ? this.selected[0] : null,
      };
    },
  }
}
</script>

<style>
.display_none {
  display: none;
}

.form-control:disabled {
  color: black;
}

.text-black {
  color: black;
}
</style>
